export const valoresExibidosProaq: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',
  modalidadeAquisicao: 'Modalidade de Aquisição',
  subtipoModalidade: 'Subtipo da Modalidade',
  tipoItemAquisitivo: 'Tipo de Item',
  unidadeDAF: 'Unidade DAF',
  produtoDAF: 'Produto Farmacêutico',
  denominacaoOuKit: 'Denominação / Kit',
  denominacaoGenerica: 'Denominação Genérica',
  KitProdutoDAF: 'Kit de Produtos',
  proaq: 'ID do Processo Aquisitivo',
  numeroSeiProaq: 'Número SEI',
  numeroEtp: 'Número ETP',
  componenteAF: 'Componente AF',
  proaqResponsavel: 'Responsável pelo Processo',
  // Fase
  fase: 'Fase',
  status: 'Status',
  faseDataEntrada: 'Data de Entrada',
  faseDataSaida: 'Data de Saída',

  // Item
  itens: 'Itens do Processo',
  numeroItem: 'Número do Item',
  produto: 'Produto',
  tipoCota: 'Tipo de Cota',
  cmmInicio: 'CMM Início',
  cmmFinal: 'CMM Final',
  cmmValorReferencia: 'CMM Valor de Referência',
  qtdASerAdquirida: 'Quant. a Adquirir',
  coberturaDias: 'Cobertura (dias)',
  coberturaMeses: 'Cobertura (meses)',
  valorUntEmbalagem: 'Valor Unitário Embalagem',
  valorTotalEstimado: 'Valor Total Estimado',
  fatorEmbalagem: 'Fator Embalagem',
  qtdEmbalagem: 'Qtd. Embalagens',
  qtdAdministrativa: 'Qtd. Administrativa',
  qtdJudicial: 'Qtd. Judicial',
  qtdEstrategico: 'Qtd. Estratégica',
  qtdOutro: 'Qtd. Outro',
  qtdTotal: 'Qtd. Total',

  // Tramitação
  tramitacoes: 'Tramitações - SEI',
  entrada: 'Entrada - Última Tramitação',
  saida: 'Saída - Última Tramitação',
  usuarioSei: 'Usuário SEI - Última Tramitação',
  dataEntrada: 'Data de Entrada',
  dataSaida: 'Data de Saída',
  seiUsuario: 'Usuário SEI',
  seiDescricao: 'Descrição',
  seiUnidade: 'Unidade MS',
  descricao: 'Descrição - Última Tramitação',
  unidadeMS: 'Unidade MS - Última Tramitação',

  // Responsável
  statusResponsavel: 'Status',
  dataInicio: 'Data - Início',
  dataFim: 'Data - Fim',
  responsavel: 'Responsável',

  // Destaques
  nivelCriticidade: 'Nível de Criticidade',
  titulo: 'Título',

  //Preço
  fornecedor: 'Fornecedor',
  dataPreco: 'Data do Preço',
  preco: 'Preço',
  isCMED: 'Preço CMED',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorItem: '',
  separadorItemQtd: '',
  separadorItemCmm: '',
  separadorItemCobertura: '',
  separadorItemValor: '',
  separadorFase: '',
  separadorTramitacao: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];

export const headersProaqs = [
  { text: '', width: 1, key: 'proaqOffcanvas' },
  { text: 'ID', width: 2, key: 'proaqID' },
  { text: 'Status', width: 8, key: 'proaqStatus' },
  // { text: 'Fase', width: 12, key: 'proaqFase' },
  { text: 'Comp. AF', width: 10, key: 'proaqComponenteAF' },
  { text: 'Mod. Aquisição', width: 10, key: 'proaqModAquisicao' },
  { text: 'Denominação/Kit', width: 25, key: 'proaqDenominacaoKit' },
  // { text: 'Responsável', width: 15, key: 'proaq' },
  { text: 'Nº Itens', width: 5, key: 'proaqQtdItens' },
  { text: 'Valor total R$', width: 8, key: 'proaqValorTotal' },
];

export const headersProaqDestaques = [
  { text: '', width: 1, key: 'proaqDestaquesOffcanvas' },
  { text: 'ID', width: 2, key: 'proaqDestaquesID' },
  { text: 'Criticidade', width: 7, key: 'proaqDestaquesCriticidade' },
  { text: 'Título', width: 35, key: 'proaqDestaquesTitulo' },
  { text: 'Descrição', width: 55, key: 'proaqDestaquesDescricao' },
];

export const headersProaqEvolucao = [
  { text: 'Nº', width: 5, key: 'proaqFaseOffcanvas' },
  { text: 'Área', width: 10, key: 'proaqFaseArea' },
  { text: 'Fase', width: 35, key: 'proaqFaseNumero' },
  { text: 'Entrada', width: 15, key: 'proaqFaseIn' },
  { text: 'Saída', width: 15, key: 'proaqFaseOut' },
  { text: 'Dias', width: 10, key: 'proaqFaseDays' },
  { text: 'Estimativa', width: 10, key: 'proaqFaseEstimativa' },
];

export const headersProaqItens = [
  { text: '', width: 1, key: 'proaqItemOffcanvas' },
  { text: 'ID', width: 2, key: 'proaqItemID' },
  { text: 'Item', width: 2, key: 'proaqItemNumero' },
  { text: 'Produto', width: 20, key: 'proaqItemProduto' },
  { text: 'Tipo Cota', width: 7, key: 'proaqItemCota' },
  { text: 'CMM - Início', width: 8, key: 'proaqItemCmmBegin' },
  { text: 'CMM - Fim', width: 8, key: 'proaqItemCmmEnd' },
  { text: 'Qtd. Total', width: 8, key: 'proaqItemQtdTotal' },
  { text: 'Qtd. Administrativa', width: 11, key: 'proaqItemQtdAdministrativa' },
  { text: 'Qtd. Judicial', width: 9, key: 'proaqItemQtdJudicial' },
  { text: 'Qtd. Estratégico', width: 9, key: 'proaqItemQtdEstrategico' },
  { text: 'Valor (Und)', width: 7, key: 'proaqItemValorUnitario' },
  { text: 'Valor Total', width: 8, key: 'proaqItemValorTotal' },
];

export const headersProaqPrecoCMED = [
  // { text: '', width: 1, key: 'proaqCMEDOffcanvas' },
  { text: 'ID', width: 4, key: 'proaqCMEDID' },
  { text: 'Data do Preço', width: 10, key: 'proaqCMEDDate' },
  { text: 'Produto', width: 35, key: 'proaqCMEDProduto' },
  { text: 'Fornecedor', width: 39, key: 'proaqCMEDFornecedor' },
  { text: 'Preço', width: 13, key: 'proaqCMEDPreco' },
];

export const headersProaqResponsaveis = [
  // { text: '', width: 1, key: 'proaqResponsavelOffcanvas' },
  { text: 'ID', width: 4, key: 'proaqResponsavelID' },
  { text: 'Status', width: 7, key: 'proaqResponsavelStatus' },
  { text: 'Data Início', width: 15, key: 'proaqResponsavelDataInicio' },
  { text: 'Data Fim', width: 15, key: 'proaqResponsavelDataFim' },
  { text: 'Responsável', width: 20, key: 'proaqResponsavelNome' },
  { text: 'Observações', width: 60, key: 'observacoes' },
];

export const proaqFaseInfoDescription = [
  {
    nFase: '1',
    titulo: 'Preparação dos Documentos Iniciais',
    subtitulo: 'Elaboração dos documentos iniciais do processo.',
    descricao:
      'Nesta fase, são realizados os primeiros passos para iniciar o processo de aquisição de produtos farmacêuticos. São elaborados os documentos iniciais, como requerimentos, solicitações e levantamento de informações preliminares. A saída do processo do DAF é o marco final dessa fase.',
  },
  {
    nFase: '2',
    titulo: 'Tramitação Interna à SECTICS',
    subtitulo:
      'Tramitação do processo pelas instâncias administrativas da SECTICS.',
    descricao:
      'Pode envolver o retorno do processo para a unidade de origem do DAF para ajustes. O marco de encerramento dessa fase é quando o processo sai da SECTICS e vai para outras secretarias do MS.',
  },
  {
    nFase: '3',
    titulo: 'Tramitação Externa à SECTICS',
    subtitulo:
      'Tramitação do processo pelas instâncias administrativas do Ministério da Saúde (Secretaria Executiva, DLOG e outros).',
    descricao:
      'Pode envolver o retorno do processo para a unidade de origem do DAF para ajustes. O encerramento dessa etapa acontece com a publicação do edital de seleção do fornecedor (se for o caso) ou a formalização do contrato com o fornecedor.',
  },
  {
    nFase: '4',
    titulo: 'Seleção do Fornecedor',
    subtitulo:
      'Dependendo da modalidade de aquisição, compreende as atividades relacionadas à seleção do fornecedor.',
    descricao:
      'Caso o processo não requeira a seleção do fornecedor, o processo pula essa etapa. O marco de finalização dessa etapa é a homologação do resultado da seleção.',
  },
  {
    nFase: '5',
    titulo: 'Contratação',
    subtitulo: 'Formalização do contrato com o fornecedor.',
    descricao:
      'Etapa que compreende todas as atividades relacionadas à formalização do contrato com o fornecedor. Nessa etapa há muita troca de documentos entre o Ministério e o fornecedor.  Esta etapa compreende até a assinatura do contrato.',
  },
  {
    nFase: '6',
    titulo: ' Execução do Contrato',
    subtitulo: 'Entrega dos produtos farmacêuticos e pagamentos.',
    descricao:
      'Nessa fase, o contrato de aquisição é executado. Os produtos farmacêuticos são entregues conforme as condições estabelecidas, e os pagamentos são realizados de acordo com os termos acordados no contrato.',
  },
  {
    nFase: '7',
    titulo: 'Prestação de Contas',
    subtitulo: 'Documentação final, restos a pagar e encerramento do contrato.',
    descricao:
      'Durante essa etapa, são reunidos todos os documentos finais relacionados à aquisição. Isso inclui a verificação de eventuais restos a pagar, a finalização de relatórios e registros e a conclusão de todas as obrigações contratuais.',
  },
  {
    nFase: '8',
    titulo: 'Processo Encerrado',
    subtitulo: 'Todos os documentos entregues e o processo está finalizado.',
    descricao:
      ' Na fase final, o contrato e o processo de aquisição dos produtos farmacêuticos estão concluídos. Todas as etapas foram finalizadas, os documentos foram arquivados corretamente e todas as obrigações contratuais foram cumpridas.',
  },
];
